import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const MinusCircleFillMedium = (props: SvgIconT.Props) => (
  <SvgIcon width={24} {...props} viewBox="0 0 24 24">
    <path d="M11.5 2.872c-4.675 0-8.5 3.825-8.5 8.5s3.825 8.5 8.5 8.5 8.5-3.825 8.5-8.5-3.825-8.5-8.5-8.5zm4.5 9H7v-1h9v1z"></path>
  </SvgIcon>
);

export default MinusCircleFillMedium;
